"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var attending_service_1 = require("../../service/attending.service");
var router_1 = require("@angular/router");
var attending_1 = require("../../model/attending");
var equipment_1 = require("../../../shared/model/equipment");
var screening_1 = require("../../model/screening");
var configuration_1 = require("../../model/configuration");
var dispatch_1 = require("../../model/dispatch");
var monitoring_1 = require("../../model/monitoring");
var scheduling_1 = require("../../model/scheduling");
var authentication_service_1 = require("../../../shared/service/authentication.service");
var toast_service_1 = require("../../../shared/service/toast.service");
var attending_info_1 = require("../../model/attending-info");
var validation_1 = require("../../model/validation");
var AttendingComponent = /** @class */ (function () {
    function AttendingComponent(_router, _route, _attendingService, _authService, _toastService) {
        this._router = _router;
        this._route = _route;
        this._attendingService = _attendingService;
        this._authService = _authService;
        this._toastService = _toastService;
        this.creating = false;
        this.wasSaved = false;
        this.attending = new attending_1.Attending();
        this.canShowAttending = false;
        this.SCREENING = 'SCREENING';
        this.CONFIGURATION = 'CONFIGURATION';
        this.DISPATCH = 'DISPATCH';
        this.SCHEDULING = 'SCHEDULING';
        this.MONITORING = 'MONITORING';
        this.VALIDATION = 'VALIDATION';
        this.isLoading = false;
        this.totalProcessingRequests = 0;
        this.setEmptyEntities();
        this.findOrCreateAttending();
        this.setUpObservers();
    }
    AttendingComponent.prototype.ngOnInit = function () {
    };
    AttendingComponent.prototype.ngOnDestroy = function () {
        if (this.creating && !this.wasSaved) {
            this._attendingService.delete(this.attending.id).subscribe();
        }
    };
    AttendingComponent.prototype.findOrCreateAttending = function () {
        var _this = this;
        this._route.params.subscribe(function (params) {
            if (params['id']) {
                _this.attendingId = +params['id'];
                _this.buildAttending(_this.attendingId);
            }
            else {
                _this.creating = true;
                _this.createAttending();
                _this.canShowAttending = true;
            }
        });
    };
    AttendingComponent.prototype.saveScreening = function (data) {
        this._attendingService.updateAttending(data);
    };
    AttendingComponent.prototype.saveConfiguration = function (data) {
        this._attendingService.saveConfiguration(data);
    };
    AttendingComponent.prototype.saveDispatch = function (data) {
        this._attendingService.saveDispatch(data);
    };
    AttendingComponent.prototype.saveScheduling = function (data) {
        this._attendingService.saveScheduling(data);
    };
    AttendingComponent.prototype.saveValidation = function (data) {
        this._attendingService.saveValidation(data);
    };
    AttendingComponent.prototype.updateMonitoring = function (data) {
        this.updateOnGoingRequestsControl();
        this._toastService.showMessage('Salvando informações do atendimento.');
        this._attendingService.updateAttending(data);
    };
    AttendingComponent.prototype.cancel = function () {
        if (this.creating) {
            this._attendingService.delete(this.attending.id)
                .subscribe(this.goBack());
        }
        else {
            this.goBack();
        }
    };
    AttendingComponent.prototype.showStep = function (step) {
        if (this.attending.orderedSteps && step) {
            return this.attending.currentStep === step || this.stepCanBeShown(step);
        }
        else {
            this.attending.orderedSteps = [this.SCREENING];
            return this.stepCanBeShown(step);
        }
    };
    AttendingComponent.prototype.stepCanBeShown = function (step) {
        return this.attending.orderedSteps.includes(step)
            && this.authenticatedUser.stepViews.find(function (view) { return view.stepViewType === step; });
    };
    AttendingComponent.prototype.setpIsEditable = function (step) {
        return step && (step.editable || step.editable === undefined);
    };
    AttendingComponent.prototype.assignMonitoringToUser = function () {
        this.updateOnGoingRequestsControl();
        this._attendingService.assignMonitoringToUser(this.attending.id);
    };
    AttendingComponent.prototype.unassignMonitoringToUser = function () {
        this.updateOnGoingRequestsControl();
        this._attendingService.unassignMonitoringToUser(this.attending.id);
    };
    AttendingComponent.prototype.updateAttendingInfo = function (id) {
        if (!this.isLoading) {
            this.updateOnGoingRequestsControl();
            this._attendingService.findAttendingInfo(id);
        }
    };
    AttendingComponent.prototype.convertAttending = function () {
        this.updateOnGoingRequestsControl();
        this._attendingService.convertAttending(this.attending.id, this.attending.attendingInfo.conversion);
    };
    AttendingComponent.prototype.updateOnGoingRequestsControl = function () {
        this.isLoading = true;
        this.totalProcessingRequests++;
    };
    AttendingComponent.prototype.updateFinishRequestControl = function () {
        if (this.totalProcessingRequests > 0) {
            this.totalProcessingRequests--;
            if (this.totalProcessingRequests === 0) {
                this.isLoading = false;
            }
        }
    };
    AttendingComponent.prototype.createAttending = function () {
        this._attendingService.create();
    };
    AttendingComponent.prototype.buildAttending = function (id) {
        this._attendingService.build(id);
    };
    AttendingComponent.prototype.setUpObservers = function () {
        var _this = this;
        this._attendingService.save$
            .subscribe(function (attending) {
            _this.updateFinishRequestControl();
            if (_this.attending.currentStep !== _this.MONITORING) {
                _this.wasSaved = true;
                _this.goBack();
            }
            else {
                _this.updateAttendingInfo(attending.attendingInfo.id);
                _this.attending = attending;
                _this._toastService.showMessage('Atendimento atualizado.');
            }
        });
        this._attendingService.finish$
            .subscribe(function () { return _this.goBack(); });
        this._attendingService.create$
            .subscribe(function (attending) {
            _this.updateFinishRequestControl();
            _this.attending = attending;
            _this.setEmptyEntities();
        });
        this._attendingService.build$
            .subscribe(function (attending) {
            _this.updateFinishRequestControl();
            _this.attending = attending;
            _this.setEmptyEntities();
            _this.canShowAttending = true;
        });
        this._attendingService.find$
            .filter(function (result) { return result instanceof attending_info_1.default; })
            .subscribe(function (attendingInfo) {
            _this.updateFinishRequestControl();
            _this.attending = __assign({}, _this.attending, { attendingInfo: attendingInfo });
        });
        this._attendingService.error$
            .subscribe(function (error) {
            _this.updateFinishRequestControl();
            _this.showMessage(error.text);
        });
    };
    AttendingComponent.prototype.setEmptyEntities = function () {
        this.authenticatedUser = this._authService.getUserFromLocalStorage();
        if (!this.attending.screening) {
            this.attending.screening = new screening_1.Screening();
        }
        if (!this.attending.configuration) {
            this.attending.configuration = new configuration_1.Configuration();
        }
        if (!this.attending.dispatch) {
            this.attending.dispatch = new dispatch_1.Dispatch();
        }
        if (!this.attending.monitoring) {
            this.attending.monitoring = new monitoring_1.Monitoring();
        }
        if (!this.attending.equipment) {
            this.attending.equipment = new equipment_1.Equipment();
        }
        if (!this.attending.scheduling) {
            this.attending.scheduling = new scheduling_1.Scheduling();
        }
        if (!this.attending.validation) {
            this.attending.validation = new validation_1.Validation();
            this.attending.validation.gps = false;
            this.attending.validation.speed = false;
            this.attending.validation.rpm = false;
            this.attending.validation.can = false;
        }
        if (!this.attending.screening.providedServices) {
            this.attending.screening.providedServices = [];
        }
    };
    AttendingComponent.prototype.goBack = function () {
        this._router.navigate(['attendings', 'list']);
    };
    AttendingComponent.prototype.showMessage = function (message) {
        this._toastService.showMessage(message, 4000);
    };
    AttendingComponent.ctorParameters = function () { return [{ type: router_1.Router }, { type: router_1.ActivatedRoute }, { type: attending_service_1.AttendingService }, { type: authentication_service_1.AuthenticationService }, { type: toast_service_1.ToastService }]; };
    return AttendingComponent;
}());
exports.AttendingComponent = AttendingComponent;
//# sourceMappingURL=attending.component.js.map


// WEBPACK FOOTER //
// attending.component.js